import DialogComponent, { DialogProps } from '../widgets/dialog/DialogComponent';

import './SensorDialog.scss';

interface Props extends DialogProps {
  id: string;
  redirect: (value: string) => void;
  onCloseClicked: () => void;
}

class SensorDialog extends DialogComponent<Props> {
  render() {
    const { id } = this.props;
    return (
      <div className="row sensor-dialog-component">
        <div className="col-12 sensor-name">
          <div className="d-flex flex-row">
            <i className="far fa-times close-icon" onClick={this.close}></i>
            <span>{id}</span>
          </div>
          <hr />
        </div>
        <div className="col-md-4 col-12">
          <div
            className="item item-chart"
            onClick={this.resolve.bind(this, '/dashboard/graph/' + id)}>
            <i className="far fa-chart-line"></i>
            <span className="item-name">نمایش گراف</span>
          </div>
        </div>
        <div className="col-md-4 col-12">
          <div
            className="item item-setting"
            onClick={this.resolve.bind(this, '/dashboard/sensors/edit/' + id)}>
            <i className="far fa-cog"></i>
            <span className="item-name">تنظیمات</span>
          </div>
        </div>
        <div className="col-md-4 col-12">
          <div className="item item-alert" onClick={this.resolve.bind(this, '/dashboard/sensor-alarms/' + id)}>
            <i className="far fa-sensor-alert"></i>
            <span className="item-name">هشدارها</span>
          </div>
        </div>
      </div>
    );
  }
}

export default SensorDialog;
